/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import Spinner from "components/spinner/spinner";
import Plus from "components/icons/plus";
import Button from "components/button/button";
import Close from "components/icons/close";
import { LoaderState } from "behaviors/loader/state";
import { TimeoutError } from "api/errors";
import { SectionNotFoundError } from "./errors";
import { t } from "i18n";

interface LoaderProps {
  loader: LoaderState;
  loadSections: () => void;
}

const Loader: React.SFC<LoaderProps> = ({ loader: { loading, error }, loadSections }) => {
  if (loading) {
    return <Spinner message={t("sections.messages.loading-list")} />;
  }
  if (error) {
    if (error instanceof TimeoutError) {
      return (
        <React.Fragment>
          <Plus width="48" height="48" />
          <p>{t("sections.messages.could-not-load-list")}</p>
          <p>
            <Button onClick={loadSections}>{t("sections.cta.load-retry")}</Button>
          </p>
        </React.Fragment>
      );
    }

    if (error instanceof SectionNotFoundError) {
      return (
        <React.Fragment>
          <Close width="48" height="48" />
          <p>{t("sections.messages.not-found", { id: error.id })}</p>
        </React.Fragment>
      );
    }
  }

  return <p>{t("sections.messages.unknown-error")}</p>;
};

export default Loader;
